import React from 'react';
import { load } from 'core/utils/DynamicPreloading';
import { getShoppingCartBehavior } from 'core/utils/cart';
import { useSelector } from 'react-redux';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';

const LazyCartInterstitialSheet = React.lazy(load(() => import('component/page/detail/CartInterstitialSheet/CartInterstitialSheet')));

const CartInterstitialContainerComponent: React.FC = React.memo(() => {
    const config = useSelector(selectConfigFromBootstrap);

    if (!getShoppingCartBehavior(config)) {
        return null;
    }

    return (
        <React.Suspense fallback={null}>
            <LazyCartInterstitialSheet />
        </React.Suspense>
    );
});

CartInterstitialContainerComponent.displayName = 'CartInterstitialContainer';

export default CartInterstitialContainerComponent;
